import { Link } from 'react-router-dom';
import { useLanguage } from '@/contexts/LanguageContext';

export default function SolutionsCTA() {
  const { t } = useLanguage();

  const capabilities = [
    { icon: 'ri-search-eye-line', text: t('材料評估', 'Material Assessment', '材料評価') },
    { icon: 'ri-test-tube-line', text: t('試產驗證', 'Pilot Production', '試験生産') },
    { icon: 'ri-settings-3-line', text: t('量產導入', 'Full-Scale Implementation', '量産導入') },
    { icon: 'ri-leaf-line', text: t('ESG 碳效益整理', 'ESG Carbon Benefit Documentation', 'ESG炭素効果整理') },
  ];

  return (
    <section className="relative section-padding overflow-hidden">
      <div className="absolute inset-0 bg-cover bg-top"
        style={{ backgroundImage: 'url(https://readdy.ai/api/search-image?query=circular%20economy%20green%20technology%20sustainable%20manufacturing%20recycled%20plastic%20products%20factory%20overview%20professional%20wide%20angle%20photography%20green%20and%20blue%20accent%20lighting%20clean%20industrial%20environment%20high%20resolution&width=1440&height=560&seq=solutions-cta-v1&orientation=landscape)' }}
      />
      <div className="absolute inset-0 bg-gradient-to-br from-black/75 via-black/62 to-black/50" />
      <div className="absolute top-0 right-0 w-[500px] h-[500px] opacity-20 pointer-events-none" style={{ background: 'radial-gradient(circle, rgba(0,184,148,0.28) 0%, transparent 65%)', zIndex: 1 }} aria-hidden="true" />

      <div className="relative z-10 max-w-screen-xl mx-auto px-4 md:px-6">
        <div className="max-w-3xl mx-auto text-center">
          <div className="w-16 h-16 flex items-center justify-center rounded-2xl bg-gradient-to-br from-brand-green to-brand-blue mx-auto mb-6">
            <i className="ri-customer-service-2-line text-white text-3xl"></i>
          </div>
          <h2
            className="font-bold text-white mb-5"
            style={{ fontSize: 'clamp(1.5rem, 3vw, 2.125rem)', lineHeight: '1.4' }}
          >
            {t(
              '正在尋找高比例再生料的可行方案？',
              'Looking for a Viable High Recycled Content Solution?',
              '高再生材料比率の実現可能なソリューションをお探しですか？'
            )}
          </h2>
          <p className="text-white/82 mb-8 max-w-xl mx-auto" style={{ fontSize: '1.1875rem', lineHeight: '1.75' }}>
            {t(
              '聚量可協助從材料評估、試產驗證到量產導入，讓循環經濟真正進入產品與市場。',
              'PolyQ can assist from material assessment and pilot production to full-scale implementation, bringing circular economy truly into products and markets.',
              '聚量は材料評価・試験生産・量産導入まで支援し、サーキュラーエコノミーを製品と市場に真に組み込みます。'
            )}
          </p>
          <div className="flex flex-wrap justify-center gap-3 mb-9">
            {capabilities.map((c) => (
              <div key={c.text} className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-white/12 border border-white/25 backdrop-blur-sm">
                <div className="w-5 h-5 flex items-center justify-center">
                  <i className={`${c.icon} text-brand-green text-base`}></i>
                </div>
                <span className="text-white text-[1rem] font-medium whitespace-nowrap">{c.text}</span>
              </div>
            ))}
          </div>
          <Link
            to="/contact"
            className="inline-flex items-center gap-2 px-8 py-4 rounded-full bg-brand-green text-white text-[1.0625rem] font-semibold hover:bg-brand-green-dark transition-all duration-200 whitespace-nowrap cursor-pointer"
          >
            <i className="ri-calendar-schedule-line"></i>
            {t('預約應用情境諮詢', 'Schedule Application Consultation', '応用シーン相談を予約')}
          </Link>
        </div>
      </div>
    </section>
  );
}
